import { produce } from 'immer';

import { RESET_STATE } from 'store/global/actions';

import { CONTACT_TYPES_ACTION_TYPE } from '../actions';

const initialState = {
  contactTypes: [],
  editorContactTypes: [],
  externalCodeFamilies: {},
};

const replaceById = (items, payload) =>
  items.map(item => (item.id === payload.id ? payload : item));

const contactTypesReducer = (state = initialState, { type, payload }) =>
  produce(state, draft => {
    switch (type) {
      case CONTACT_TYPES_ACTION_TYPE.GET_CONTACT_TYPES:
        draft.contactTypes = payload;
        break;

      case CONTACT_TYPES_ACTION_TYPE.GET_EDITOR_CONTACT_TYPES:
        draft.editorContactTypes = payload;
        break;

      case CONTACT_TYPES_ACTION_TYPE.GET_EXTERNAL_CODE_FAMILIES:
        draft.externalCodeFamilies[payload.provider] = payload.families;
        break;

      case CONTACT_TYPES_ACTION_TYPE.CREATE_CONTACT_TYPE:
        draft.contactTypes = [...state.contactTypes, payload];
        draft.editorContactTypes = [...state.editorContactTypes, payload];
        break;

      case CONTACT_TYPES_ACTION_TYPE.UPDATE_CONTACT_TYPE:
        draft.contactTypes = replaceById(state.contactTypes, payload);
        draft.editorContactTypes = replaceById(state.editorContactTypes, payload);
        break;

      case CONTACT_TYPES_ACTION_TYPE.DELETE_CONTACT_TYPE:
        draft.contactTypes = state.contactTypes.filter(item => item.id !== payload);
        draft.editorContactTypes = state.editorContactTypes.filter(item => item.id !== payload);
        break;

      case RESET_STATE:
      case CONTACT_TYPES_ACTION_TYPE.RESET_CONTACT_TYPES_STATE:
        return initialState;

      default:
        break;
    }
  });

export default contactTypesReducer;
